import { render } from "./Calculator.vue?vue&type=template&id=96184766&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"

import "./Calculator.vue?vue&type=style&index=0&id=96184766&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-96184766"

export default script